module.exports = __webpack_public_path__ + "static/media/TL.3459bf09.svg";